import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolicyDetailsService } from './services/policydetails.service';
import { PolicyDetailsRoutingModule } from './policydetails-routing.module';
import { SystemCommonModule } from '../system-common/system-common.module';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PolicyDetailsStepFormComponent } from './policy-details-step-form/policy-details-step-form.component';
import { PolicyListingSearchComponent } from './policy-listing-search/policy-listing-search.component';
import { ProposalListingSearchComponent } from './proposal-listing-search/proposal-listing-search.component';
import { PremiumDueSearchComponent } from './premium-due-search/premium-due-search.component';
import { PremiumPaidHistorySearchComponent } from './premium-paid-history-search/premium-paid-history-search.component';
import { MyPoliciesSearchComponent } from './my-policies-search/my-policies-search.component';
import { MyCustomersSearchComponent } from './my-customers-search/my-customers-search.component';

@NgModule({
  declarations: [
    PolicyDetailsStepFormComponent,
    PolicyListingSearchComponent,
    MyPoliciesSearchComponent,
    MyCustomersSearchComponent,
    ProposalListingSearchComponent,
    PremiumDueSearchComponent,
    PremiumPaidHistorySearchComponent,
  ],
  imports: [
    CommonModule,
    PolicyDetailsRoutingModule,
    SystemCommonModule,
    FormsModule,
    NgSelectModule,
    ModalModule.forRoot(),
  ],
  exports: [PremiumDueSearchComponent],
  providers: [PolicyDetailsService],
})
export class PolicydetailsModule {}
